module.exports = __webpack_public_path__ + "static/media/bg_room_temp.1a494511.png";